var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-button",class:[
        { 'group-button--error': _vm.hasError },
        _vm.groupButtonPredefinedStyle ]},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"group-button__button button",class:[
            { 'button--active': _vm.isOptionSelected(option) },
            { 'ff-tertiary': _vm.squad },
            { 'color-fl-green-middle': _vm.squad && _vm.isOptionSelected(option) }
        ],on:{"click":function($event){_vm.selectOption(option)}}},[_vm._v(_vm._s(option[_vm.labelField]))])}))}
var staticRenderFns = []

export { render, staticRenderFns }